<div class="header">
	<div class="row main-header">
		<div class="logo">
			<a id="company-a-link"
				[ngClass]="company_text !== '' ? 'company-link' : 'company-link-default'" aria-label="LJH Realty home">
				<span id="company-image" [ngClass]="company_text !== '' ? 'company-logo' : 'company-logo-default'"
					role="img" aria-label="LJH Realty logo"></span>
				<span id="company_name" [ngClass]="company_text !== '' ? 'company-name' : 'd-none'"></span>
			</a>
		</div>
		<div class="nav-items">
			<a [routerLink]="homeLink" class="xl-only-menu about"
				[ngClass]="activeUrl() ? 'active' : ''"><span>Home</span></a>
			<a [id]="find_propertiesTriggerId" class="xl-only-menu about" [ngClass]="activeUrl() ? 'active' : ''">
				<span>{{ 'find-property' | translate }}</span><img src="/assets/icon/header/chevorn-down.svg">
				<hr>
				<ion-popover id="find_property" [trigger]="find_propertiesTriggerId" triggerAction="hover"
					alignment="center" [showBackdrop]="false" [dismissOnSelect]="true">
					<ng-template>
						<ion-content [scrollY]="false">
							<span class="arrow-icon"></span>
							<div class="content">
								<ion-list>
									@for (find_property of find_properties; track find_property.id; let i = $index) {
									<ion-item lines="none" [button]="true"
										[ngClass]="i !== find_properties.length - 1 ? 'line' : 'none'"
										routerLinkActive="active" [routerLink]="localizedUrl(find_property.url)"
										[detail]="false">
										<ion-label>{{ find_property.name | translate }}</ion-label>
									</ion-item>
									}
								</ion-list>
							</div>
						</ion-content>
					</ng-template>
				</ion-popover>
			</a>
			<a [routerLink]="localizedUrl('/proyek-rumah')" class="xl-only-menu about"
				[ngClass]="activeUrl() ? 'active' : ''"><span>{{ 'new-property' | translate }}</span></a>
			<a [id]="infoPropertyTriggerId" class="xl-only-menu about" [ngClass]="activeUrl() ? 'active' : ''">
				<span>{{ 'info-property' | translate }}</span><img src="/assets/icon/header/chevorn-down.svg">
				<hr>
				<ion-popover id="info-properties" [trigger]="infoPropertyTriggerId" triggerAction="hover"
					alignment="center" [showBackdrop]="false" [dismissOnSelect]="true">
					<ng-template>
						<ion-content [scrollY]="false">
							<span class="arrow-icon"></span>
							<div class="content">
								<ion-list>
									@for (info of info_property; track info.id; let i = $index) {
									<ion-item lines="none" [button]="true"
										[ngClass]="i !== info_property.length - 1 ? 'line' : 'none'"
										routerLinkActive="active" [routerLink]="localizedUrl(info.url)"
										[detail]="false">
										<ion-label>{{ info.name | translate }}</ion-label>
									</ion-item>
									}
								</ion-list>
							</div>
						</ion-content>
					</ng-template>
				</ion-popover>
			</a>
			<a [id]="businessTriggerId" class="xl-only-menu about" [ngClass]="activeUrl() ? 'active' : ''">
				<span>{{ 'join-ljh-realty' | translate }}</span><img src="/assets/icon/header/chevorn-down.svg">
				<hr>
				<ion-popover id="join-ljh-realty" [trigger]="businessTriggerId" triggerAction="hover" alignment="center"
					[showBackdrop]="false" [dismissOnSelect]="true">
					<ng-template>
						<ion-content [scrollY]="false">
							<span class="arrow-icon"></span>
							<div class="content">
								<ion-list>
									@for (business of businesses; track business.id; let i = $index) {
									<ion-item lines="none" [button]="true"
										[ngClass]="i !== businesses.length - 1 ? 'line' : 'none'"
										routerLinkActive="active" [routerLink]="localizedUrl(business.url)"
										[detail]="false">
										<ion-label>{{ business.name | translate }}</ion-label>
									</ion-item>
									}
								</ion-list>
							</div>
						</ion-content>
					</ng-template>
				</ion-popover>
			</a>
			<a [id]="aboutUsTriggerId" class="xl-only-menu about" [ngClass]="activeUrl() ? 'active' : ''">
				<span>{{ 'about-us' | translate }}</span><img src="/assets/icon/header/chevorn-down.svg">
				<hr>
				<ion-popover id="about" [trigger]="aboutUsTriggerId" triggerAction="hover" alignment="center"
					[showBackdrop]="false" [dismissOnSelect]="true">
					<ng-template>
						<ion-content [scrollY]="false">
							<span class="arrow-icon"></span>
							<div class="content">
								<ion-list>
									@for (about_us of about_uses; track about_us.id; let i = $index) {
									<ion-item lines="none" [button]="true"
										[ngClass]="i !== about_uses.length - 1 ? 'line' : 'none'"
										routerLinkActive="active" [routerLink]="localizedUrl(about_us.url)"
										[detail]="false">
										<ion-label>{{ about_us.name | translate }}</ion-label>
									</ion-item>
									}
								</ion-list>
							</div>
						</ion-content>
					</ng-template>
				</ion-popover>
			</a>
			<button type="button" [id]="languageTriggerId" class="xl-only-menu language-menu nav-trigger">
				<span>{{ 'language' | translate }}</span><img src="/assets/icon/header/chevorn-down.svg" alt="">
			</button>
			<ion-popover id="lang" [trigger]="languageTriggerId" triggerAction="click" alignment="center"
				[showBackdrop]="false" [dismissOnSelect]="true">
				<ng-template>
					<ion-content [scrollY]="false">
						<span class="arrow-icon"></span>
						<div class="content">
							<ion-list>
								<ion-item [button]="true" (click)="switchId($event)" [detail]="false">
									<ion-label>{{ 'IND' | translate }}</ion-label>
								</ion-item>
								<ion-item lines="none" [button]="true" (click)="switchEn($event)" [detail]="false">
									<ion-label>{{ 'ENG' | translate }}</ion-label>
								</ion-item>
							</ion-list>
						</div>
					</ion-content>
				</ng-template>
			</ion-popover>
			<a [routerLink]="localizedUrl('/contactus')" class="xl-only-menu contact-us">
				<span>
					<ion-icon name="call"></ion-icon>{{ 'contact-us' | translate }}
				</span>
			</a>
		</div>
		<div id="mobile-menu" class="menu-button mobile-show">
			<button type="button" class="menu-btn" (click)="openMenu()" aria-label="Open menu">
				<ion-icon name="menu"></ion-icon>
			</button>
		</div>
	</div>
</div>
